import * as styles from './loader.styles';

/**
 * AIR Trainer Loader - "Human in the Loop" animation
 *
 * A lightweight CSS-only animation representing human-AI collaboration:
 * - Left & right dots pulse representing AI activity
 * - Center dot with expanding ring represents human trainer taking over
 */
export const Loader = () => (
  <div className={styles.loaderContainerStyles}>
    <svg className={styles.loaderSvgStyles} viewBox='0 0 100 50' aria-label='Loading' role='img'>
      {/* Left dot (AI) */}
      <circle cx='25' cy='25' r='5' className={styles.dotLeftStyles} />

      {/* Center ring (Human taking over pulse) */}
      <circle cx='50' cy='25' r='12' className={styles.ringStyles} />

      {/* Center dot (Human trainer) */}
      <circle cx='50' cy='25' r='5' className={styles.dotCenterStyles} />

      {/* Right dot (AI response) */}
      <circle cx='75' cy='25' r='5' className={styles.dotRightStyles} />
    </svg>
  </div>
);
